import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { TESTIMONIALS } from "../../data/content";

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <p className="font-body text-xs uppercase tracking-[0.2em] font-semibold text-ov-green mb-6">
            Trusted by owners &amp; investors
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-ov-navy leading-tight tracking-tight">
            Confidence, <span className="italic text-ov-green">documented.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <div className="h-full flex flex-col p-8 border border-ov-navy/10 rounded-2xl hover:border-ov-green/40 transition-colors duration-300">
                <Quote className="text-ov-green mb-6" size={28} />
                <p className="font-body text-ov-charcoal/80 leading-relaxed flex-1">{t.quote}</p>
                <div className="mt-8 pt-6 border-t border-ov-navy/10">
                  <div className="font-display text-lg text-ov-navy">{t.name}</div>
                  <div className="font-body text-sm text-ov-charcoal/50">{t.role}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
